export const Marquee = () => {
  const items = [
    "Live Chat Support",
    "Virtual Assistants",
    "Customer Service",
    "Lead Generation",
    "Admin Support",
    "24/7 Coverage",
    "Omnichannel",
    "Fully Managed",
  ];
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="bg-[#0A0A0A] text-white border-y border-[#0A0A0A] overflow-hidden py-4"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <span
            key={i}
            className="font-display font-bold uppercase tracking-tight text-sm mx-8 inline-flex items-center gap-8"
          >
            {t}
            <span className="w-1.5 h-1.5 bg-[#002DFF] inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};
